/*
 * @CopyRight    : 广州仰望星空云科技有限公司
 * @Author       : Kyle
 * @Email        : linyukai@xinyu668.com
 * @CreateTime   : 2023-08-18 16:41:29
 * @Description  : 指令集合
 */

import { isSupportWebp, isSupportAvif } from '@UTILS/pic'
import { isType, validate } from '@ywxk/util/validate'

const toWebp = (el, binding) => {
  if (!binding.value) {
    el.style.backgroundImage = null
    return binding.value
  }
  if (!binding.value || !isType('String', binding.value)) {
    el.style.backgroundImage = null
    return console.error('The directive "to-webp" agrument must be of type String, but receive ', binding.value)
  }
  if (validate('dataUrl', binding.value)) {
    el.style.backgroundImage = 'url(' + binding.value + ')'
  } else {
    const isAdded = binding.value.indexOf('x-oss-process=image') !== -1
    let suffix = ''
    if (!isAdded) {
      if (isSupportAvif) {
        suffix = '?x-oss-process=image/format,avif'
      } else if (isSupportWebp) {
        suffix = '?x-oss-process=image/format,webp'
      }
    }
    el.style.backgroundImage = 'url(' + binding.value + suffix + ')'
  }
}

// 自动聚焦
const autoFocus = (el) => {
  el.focus()
}

export default {
  'to-webp': {
    created: toWebp,
    beforeUpdate: toWebp,
  },
  'auto-focus': {
    mounted: autoFocus,
  },
}
